import { DragEvent } from 'react';

import { DragAndDropDesignTokens } from './platformStyles';

export interface NativeDragPreviewMeasurement {
    height: number;
    width: number;
}

/** Uses a complete source clone for native drags instead of the handle alone. */
export const setNativeDragPreview = (
    event: DragEvent<HTMLElement>,
    source: HTMLElement,
    token: DragAndDropDesignTokens,
): NativeDragPreviewMeasurement => {
    const rect = source.getBoundingClientRect();
    const measurement = { height: rect.height, width: rect.width };

    if (typeof event.dataTransfer.setDragImage !== 'function') {
        return measurement;
    }

    const preview = source.cloneNode(true) as HTMLElement;
    const offsetX = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
    const offsetY = Math.max(0, Math.min(event.clientY - rect.top, rect.height));

    Object.assign(preview.style, {
        backgroundColor: token.colorBgElevated,
        borderRadius: `${token.borderRadiusLG}px`,
        boxShadow: token.boxShadowSecondary,
        boxSizing: 'border-box',
        height: `${rect.height}px`,
        left: '-10000px',
        opacity: '0.98',
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'fixed',
        top: '-10000px',
        width: `${rect.width}px`,
    });
    document.body.appendChild(preview);
    event.dataTransfer.setDragImage(preview, offsetX, offsetY);

    if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => preview.remove());
    } else {
        window.setTimeout(() => preview.remove(), 0);
    }

    return measurement;
};
